import { render, staticRenderFns } from "./NewsSubmenu.vue?vue&type=template&id=21e82c67&scoped=true"
var script = {}
import style0 from "./NewsSubmenu.vue?vue&type=style&index=0&id=21e82c67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e82c67",
  null
  
)

export default component.exports